import { render, staticRenderFns } from "./LegoCardPayload.vue?vue&type=template&id=576c7d2b&scoped=true&"
import script from "./LegoCardPayload.vue?vue&type=script&lang=ts&"
export * from "./LegoCardPayload.vue?vue&type=script&lang=ts&"
import style0 from "./LegoCardPayload.vue?vue&type=style&index=0&id=576c7d2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c7d2b",
  null
  
)

export default component.exports